// Fixed Hover Menu JavaScript for Shopify Dawn Theme

document.addEventListener('DOMContentLoaded', function() {
    // Get all menu parent items
    const menuParents = document.querySelectorAll('.hover-menu-parent');

    // Track if mouse is over menu
    let isOverMenu = false;
    let activeMenu = null;
    let closeTimeout;

    // Handle hover functionality with improved stability
    menuParents.forEach(parent => {
        const menuItem = parent.querySelector('.header__menu-item');
        const submenu = parent.querySelector('.header__submenu-container');

        if (!menuItem || !submenu) return;

        // Mouse enter parent menu item
        parent.addEventListener('mouseenter', function() {
            clearTimeout(closeTimeout);
            isOverMenu = true;

            // Close any other open menus
            if (activeMenu && activeMenu !== submenu) {
                hideMenu(activeMenu);
            }

            // Show this menu
            showMenu(submenu);
            activeMenu = submenu;
        });

        // Mouse leave parent menu item
        parent.addEventListener('mouseleave', function() {
            isOverMenu = false;

            // Set a timeout to close menu (allows moving to submenu)
            closeTimeout = setTimeout(() => {
                if (!isOverMenu) {
                    hideMenu(submenu);
                    activeMenu = null;
                }
            }, 100); // Short delay to check if mouse moved to submenu
        });

        // Handle the submenu specifically
        submenu.addEventListener('mouseenter', function() {
            clearTimeout(closeTimeout);
            isOverMenu = true;
        });

        submenu.addEventListener('mouseleave', function() {
            isOverMenu = false;
            closeTimeout = setTimeout(() => {
                if (!isOverMenu) {
                    hideMenu(submenu);
                    activeMenu = null;
                }
            }, 100);
        });

        // Keyboard accessibility
        menuItem.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();

                if (window.getComputedStyle(submenu).display === 'block') {
                    hideMenu(submenu);
                    activeMenu = null;
                } else {
                    // Close any other open menus
                    if (activeMenu) {
                        hideMenu(activeMenu);
                    }
                    showMenu(submenu);
                    activeMenu = submenu;
                }
            }
        });

        // Click functionality for mobile
        menuItem.addEventListener('click', function(e) {
            // Only handle clicks on mobile/tablet
            if (window.innerWidth <= 990) {
                // If the menu item has a submenu, prevent default action on mobile
                if (submenu) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (window.getComputedStyle(submenu).display === 'block') {
                        hideMenu(submenu);
                        activeMenu = null;
                    } else {
                        // Close any other open menus
                        if (activeMenu) {
                            hideMenu(activeMenu);
                        }
                        showMenu(submenu);
                        activeMenu = submenu;
                    }
                }
            }
        });
    });

    // Helper function to show menu
    function showMenu(menu) {
        menu.style.display = 'block';
        menu.style.opacity = '0';

        // Force a reflow to ensure the transition works
        void menu.offsetWidth;

        menu.style.opacity = '1';
        menu.style.transform = 'translateX(-50%) translateY(0)';
        menu.style.pointerEvents = 'auto';
    }

    // Helper function to hide menu
    function hideMenu(menu) {
        menu.style.opacity = '0';
        menu.style.transform = 'translateX(-50%) translateY(10px)';
        menu.style.pointerEvents = 'none';

        setTimeout(() => {
            if (menu.style.opacity === '0') {
                menu.style.display = 'none';
            }
        }, 300);
    }

    // Close menus when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.hover-menu-parent') && activeMenu) {
            hideMenu(activeMenu);
            activeMenu = null;
        }
    });

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            // Close all menus on resize
            if (activeMenu) {
                hideMenu(activeMenu);
                activeMenu = null;
            }

            // Reposition menus on resize
            menuParents.forEach(parent => {
                const submenu = parent.querySelector('.header__submenu-container');
                if (submenu && window.innerWidth > 749) {
                    submenu.style.position = 'absolute';
                } else if (submenu) {
                    submenu.style.position = 'static';
                }
            });
        }, 250);
    });
});